export class AppengineHealth {
  public static PLATFORM = 'App Engine Service';
}
